export default (ctx, key) => {
  let strings = {
    "organization_invite_title": "Membership invitation",
    "organization_invite_message": `Organization ${ctx.organization} has invited you to become ${(ctx.role == "owner")?"an":"a"} ${ctx.role}.`,
    "organization_org_invite_title": "Organization invitation",
    "organization_org_invite_message": `${ctx.organization} has invited your organization ${ctx.user} to become ${(ctx.role == "owner")?"an":"a"} ${ctx.role}.`
  }
  return strings[key]
}